import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Properties from "@/pages/Properties";
import Admin from "@/pages/Admin";

const LIVE_DOMAIN = "urbanveera.com";

function App() {
  useEffect(() => {
    const { hostname, pathname, search } = window.location;
    // Canonicalize to the apex domain: cookies and CORS are origin-bound, so
    // www.urbanveera.com and urbanveera.com would otherwise behave differently.
    if (hostname.startsWith("www.")) {
      window.location.replace(`https://${hostname.slice(4)}${pathname}${search}`);
      return;
    }
    if (process.env.REACT_APP_PREVIEW_REDIRECT === "on" && hostname.endsWith("preview.emergentagent.com")) {
      window.location.replace(`https://${LIVE_DOMAIN}${pathname}${search}`);
    }
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
